import React from 'react';
import { IStoresPanel } from '../../../../../../../../theme/ui/Dashboard/Dashboard.model';
import StoreWorkspacePanel from './StoreWorkspacePanel';
import { LayoutItem } from 'react-grid-layout';
import StoreGroupPanel from './StoreGroupPanel';
import StoreUserPanel from './StoreUserPanel';
import StoreWorkspacesPanel from './StoreWorkspacesPanel';
import { Alert } from '@mui/material';
import { useTranslation } from 'react-i18next';

export interface StorePanelProps {
  panel: IStoresPanel;
  layout?: LayoutItem | undefined;
}
function StorePanel(props: StorePanelProps) {
  const { panel, layout } = props;
  const { typeRequest } = panel;
  const { t } = useTranslation();
  switch (typeRequest) {
    case 'workspace':
      return <StoreWorkspacePanel panel={panel} layout={layout} />;
    case 'group':
      return <StoreGroupPanel panel={panel} layout={layout} />;
    case 'user':
      return <StoreUserPanel panel={panel} layout={layout} />;
    case 'workspaces':
      return <StoreWorkspacesPanel panel={panel} layout={layout} />;
    default:
      console.error(`Unknown typeRequest: ${typeRequest}`);
      return (
        <Alert severity="error">
          {t('dashboard.error.unsupported_panel_type')}
        </Alert>
      );
  }
}

export default StorePanel;
